import { Component, Vue, PropSync, Watch } from 'vue-property-decorator';
import TitleButton from '@/components/general/titlebutton/TitleButton.vue';
import DexieDBProvider from '@/services/DexieDBProvider';
import { SynchronizationService, AppSettingsService, AuthentificationService } from '@/services/index';
import { AppSettings } from '@/models/settings/AppSettings';
import { AppSettingsStore } from '@/store/store.appSettings';
import { LoggerService } from '@/utils';


@Component({
    components: {
        TitleButton,
    },
})
export default class DebugMenuComponent extends Vue {
    @PropSync('show', { type: Boolean }) public syncedShow!: boolean;
    public debugEnabled: boolean = process.env.VUE_APP_DEVELOPE === 'true';
    public autoSyncSwitch: boolean = false;

    private appSettings?: AppSettings;

    // tslint:disable-next-line: no-empty
    public async mounted() {
        AppSettingsService.OnAppSettingsLoaded.on((inAppSettings) => {
            this.onAppSettingsChanged(inAppSettings);
        });
    }

    public beforeDestroy() {
        AppSettingsService.OnAppSettingsLoaded.off(() => null);
    }

    public onAppSettingsChanged(newValue?: AppSettings) {
        if (newValue !== undefined) {
            if (newValue && newValue.autoSync !== this.autoSyncSwitch) {
                this.autoSyncSwitch = newValue.autoSync;
            }
        } else {
            LoggerService.LogError(`Error on onAppSettingsChanged, appsettings undefined`);
        }
    }

    @Watch('autoSyncSwitch')
    public onAutoSyncSwitchChanged(newValue: boolean) {
        this.toggleSyncService(newValue);
    }

    public async clearLocalData() {
        await DexieDBProvider.getInstance().deleteDataBase();
        this.syncedShow = false;
        // reload page
        this.$router.go(0);
    }

    public toggleSyncService(on: boolean) {
        if (on === true) {
            LoggerService.LogDebug(`toggleSyncService: ${on} --> StartSyncService`);
            AppSettingsService.SetAutoSync(true);
            SynchronizationService.StartSyncService();
        } else {
            LoggerService.LogDebug(`toggleSyncService: ${on} --> StopSyncService`);
            AppSettingsService.SetAutoSync(false);
            SynchronizationService.StopSyncService();
        }
    }

    public manualSync() {
        SynchronizationService.SyncNow();
        SynchronizationService.SyncFiltersNow();
    }

    public silentRefresh() {
        // TODO: trigger silent refresh
        AuthentificationService.SignInSilent();
    }

    public logout() {
        AuthentificationService.SingOutRedirect();
    }
}
